<template>
	<div class="list-group-item flex-center">
		<div class="flex-center">
			<i class="material-icons md-28 mr-3 color-black">{{ icon }}</i>
			<div>
				<div class="text-bold">{{ label }}</div>
				<small class="text-secondary" v-html="this.sanitizeHtml(info)"></small>
			</div>
		</div>
		<i
			class="material-icons ml-a cur-p md-20"
			v-tooltip="$t('Logout this device')"
			@click="remove">close</i>
	</div>
</template>

<script>
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { getUserDeviceLabel, getUserDeviceIcon, sanitizeHtml } from '@/lib/helper';

dayjs.extend(relativeTime);
dayjs.extend(customParseFormat);

export default {
	name: 'UserDevice',
	props: {
		data: {
			type: Object,
		},
	},
	methods: {
		remove() {
			this.$emit('remove', this.data);
		},
		sanitizeHtml,
	},
	computed: {
		icon() {
			const icon = getUserDeviceIcon(this.data);
			return icon;
		},
		label() {
			return getUserDeviceLabel(this.data);
		},
		info() {
			const browser = this.data.browser && this.data.browser !== '' ? this.data.browser : 'Browser unknown ';
			const activeDate = this.data.last_active;
			const lastActiveDate = dayjs(activeDate, 'DD-MM-YYYY HH:mm');
			const now = dayjs();
			const minutesDifference = now.diff(lastActiveDate, 'minute');
			const activeTreshold = 5; // 5 minutes
			const lastActiveString = minutesDifference <= activeTreshold ? '<span class="text-success text-bold">Active now</span>' : lastActiveDate.fromNow();
			return `${browser} - ${lastActiveString}`;
		},
	},
};
</script>
